import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-instaflix',
  templateUrl: './instaflix.component.html',
  styleUrls: ['./instaflix.component.scss'],
  animations: [
    trigger('scrollAnimation', [
      state('show', style({
        opacity: 1,
        transform: "translateX(0)"
      })),
      state('hide',   style({
        opacity: 0,
        transform: "translateX(-100%)"
      })),
      transition('show => hide', animate('700ms ease-out')),
      transition('hide => show', animate('700ms ease-in'))
    ])
  ]
})
export class InstaFlixComponent implements OnInit {
  title = 'Insta Flix';
  isCollapsed = true;
  cur = 'cover';
  state = 'hide'

  constructor(public el: ElementRef,private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle("Insta Flix | Suramprady");
  }
  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    const componentPosition = this.el.nativeElement.offsetTop
    const scrollPosition = window.pageYOffset
    console.log("scroll "+ scrollPosition);
    
    if (scrollPosition >= componentPosition) {
      this.state = 'show'
    } else {
      this.state = 'hide'
    }

  }

  onSectionChange(sectionId: string) {
    this.cur = sectionId;
  }

  scrollTo(section) {
    document.querySelector('#' + section)
    .scrollIntoView({ block: 'start',  behavior: 'smooth' });
  }

}